export const phoneValidator = {
    name: 'phone-format',
    validate: value => {
        if (!value) return true;
        const re = /^\d{10}$/;
        return re.test(value);
    },
};
